"use strict";

exports.__esModule = true;

var time_1 = require("./time");

var getAriaLabelForVideoPlayer = function getAriaLabelForVideoPlayer(streamInfo, duration) {
  var label = 'Spela';

  if (streamInfo) {
    label += " " + streamInfo.programTitle + " \u2014 " + streamInfo.episodeTitle;

    if (typeof duration === 'number') {
      label += ", " + time_1.formatToHoursAndMinutes(duration);
    }
  }

  return label;
};

exports["default"] = getAriaLabelForVideoPlayer;